"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnreadNotificationIDs = exports.getSelectedNotificationIDs = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function getSelectedNotificationIDs(data) {
    const values = Object.values(data);
    const filteredData = getFilteredData(values, 'selected', true);
    return getIdentifiers(filteredData);
}
exports.getSelectedNotificationIDs = getSelectedNotificationIDs;
function getUnreadNotificationIDs(notifications) {
    const filteredData = getFilteredData(notifications, 'status', bridge_schema_1.NotificationStatus.Unread);
    return getIdentifiers(filteredData);
}
exports.getUnreadNotificationIDs = getUnreadNotificationIDs;
const getFilteredData = (data, key, value) => {
    return data.filter((item) => item[key] === value);
};
const getIdentifiers = (data) => data.map(item => item.identifier);
